angular.module('admin')
.controller('AdminInviteController', ['$scope', '$uibModal', '$timeout', 'Notification', 'ModalHandler', 'ProviderInvitation', 'Logger', 'Practice', 'Auth', 'Address',
    function ($scope, $uibModal, $timeout, Notification, ModalHandler, ProviderInvitation, Logger, Practice, Auth, Address) {
        $scope.invitedColleagues = [];
        $scope.searchCollapsed = true;

        // DCL-574: the id no longer selects the practice -- the server answers
        // for the session's, since ability.rb grants `can :manage, :all` to
        // every non-guest and nothing else could keep one practice's
        // invitations out of another's page. It is still sent because
        // load_and_authorize_resource looks the practice up by it.
        Practice.getAllInvitees({id: $scope.$parent.auth.practice_id}, function(allInvitees) {
            allInvitees.forEach(function(invitation) {
                // roles_mask is what tells a user invitation from a colleague
                // one. User invitations belong to the users page, which has its
                // own controller and endpoint; this page lists colleagues only.
                if (!invitation.roles_mask) {
                    $scope.invitedColleagues.push(invitation);
                }
            });
        });

        $scope.searchAddresses = function(searchPhrase) {
            $scope.noResults = false;
            Address.search({search: searchPhrase}, function(result) {
                $scope.addresses = result;
                $scope.searchCollapsed = false;
                if (result.length < 1) {
                    $scope.noResults = true;
                }

            })
        };

        $scope.inviteDialog = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/provider_form.html',
                controller: 'ProviderModalController',
                resolve: {
                    dependsOnReferral: function() {
                        return false;
                    },
                    inviterId: function() {
                        return Auth.getOrRedirect().id;
                    }
                }
            });
            ModalHandler.set(modalInstance);
            modalInstance.result.then(function (result) {
                var provider = result.provider;

                var newModalInstance = $uibModal.open({
                    templateUrl: 'partials/invite_practice_result.html',
                    controller: 'InvitePracticeResultController',
                    resolve: {
                        toEmail: function() {
                            return provider.email;
                        }
                    }
                });
                ModalHandler.set(newModalInstance);
                
                $scope.invitedColleagues.push(provider);
            }).catch(function () {
                // Logger.log('Modal dismissed');
            });
        };

        $scope.resendInvitation = function(id) {
            ProviderInvitation.resend({id: id}, function(success) {
                Notification.success("Invitation sent successfully");
            });
        };

        // loading map with practices
        function getMapElement() {
            return document.getElementById('practices-map');
        }

        // DCL-702: other practices write these values, and a string passed to
        // InfoWindow.setContent is parsed as HTML, so they go in as text nodes.
        function markerInfoContent(properties) {
            var list = document.createElement('ul');
            list.className = 'marker-info';
            ['name', 'type', 'address'].forEach(function(field) {
                var item = document.createElement('li');
                item.className = field;
                item.textContent = properties[field];
                list.appendChild(item);
            });

            var content = document.createElement('div');
            content.style.width = '150px';
            content.appendChild(list);
            return content;
        }

        $scope.initMap = function() {
            let mapElement = getMapElement();

            const USA_BOUNDS = {
                north: 49.38,
                south: 25.82,
                west: -124.39,
                east: -66.94,
            };

            $scope.map = new google.maps.Map(mapElement, {
                zoom: 3,
                center: { lat: 37.60, lng: -95.66 },
                mapId: "dbb57afd285eb4a8146924c9",
                restriction: {
                    latLngBounds: USA_BOUNDS,
                    strictBounds: false,
                }
            });

            // Replace Data layer markers with AdvancedMarkerElement to avoid deprecated google.maps.Marker
            var infowindow = new google.maps.InfoWindow();

            // Load GeoJSON and create AdvancedMarkerElement instances
            Practice.getGeoJson().$promise
                .then(function(geojson) {
                    var features = (geojson && geojson.features) || [];
                    features.forEach(function(f) {
                        if (!f || !f.geometry) { return; }
                        if (f.geometry.type !== 'Point') { return; }
                        var coords = f.geometry.coordinates; // [lng, lat]
                        if (!coords || coords.length < 2) { return; }
                        var position = { lat: coords[1], lng: coords[0] };
                        var properties = f.properties || {};

                        var marker = new google.maps.marker.AdvancedMarkerElement({
                            map: $scope.map,
                            position: position
                        });

                        marker.addListener('click', function() {
                            infowindow.setContent(markerInfoContent(properties));
                            infowindow.setPosition(position);
                            infowindow.setOptions({ pixelOffset: new google.maps.Size(0, -30) });
                            infowindow.open($scope.map);
                        });
                    });
                })
                .catch(function(error) {
                    // Fallback: leave map empty if GeoJSON fails to load
                    Logger && Logger.log && Logger.log('Failed to load practices GeoJSON', error);
                });
        }
   
        $scope.loadMapScript = function() {
            // Check if Google Maps API is already loaded
            if (window.google && window.google.maps) {
                // API already loaded, just initialize the map
                if (!$scope.map && getMapElement()) {
                    $scope.initMap();
                }
                return;
            }

            // Check if script is currently being loaded
            if (window.googleMapsLoading) {
                return;
            }

            // Only load if map element exists and map not yet initialized
            if (!$scope.map && getMapElement()) {
                window.googleMapsLoading = true;
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.async = true;
                script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAZRhUYj0BICpRYrzz09wynSPVRFBA3DbU&v=weekly&libraries=marker&loading=async';
                
                script.onload = function() {
                    window.googleMapsLoading = false;
                    $timeout(function() {
                        $scope.initMap();
                    }, 100);
                };
                
                script.onerror = function() {
                    window.googleMapsLoading = false;
                    Logger && Logger.log && Logger.log('Failed to load Google Maps API');
                };
                
                document.body.appendChild(script);
            }
        }
    }]);